/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";
import { InviteUserProps } from "./components";

const is = require("is_js");

const SERVICE_NAME = "BlockListUserPageService";
const log: any = LoggerModule.getInstance();

export class BlockListUserPageService {
  private static instance: BlockListUserPageService;
  private vapp: VApplication;
  private loginRestAPI: string;
  private criteria: any;
  private criteriaDelegate: any;
  private headers: any;
  private token: string;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
    this.loginRestAPI = props?.loginRestAPI;
    this.headers = props?.headers;
    this.token = props?.token;
  }

  public static getInstance(props: any = {}): BlockListUserPageService {
    if (!BlockListUserPageService.instance) {
      BlockListUserPageService.instance = new BlockListUserPageService(props);
    }
    return BlockListUserPageService.instance;
  }

  private setCriteria(data: any) {
    this.criteria = data;
  }

  public resetCriteria() {
    this.criteria = null;
  }

  private setCriteriaDelegate(data: any) {
    this.criteriaDelegate = data;
  }

  public resetCriteriaDelegate() {
    this.criteriaDelegate = null;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getPageContent(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    if (args?.criteria) {
      this.setCriteria(args?.criteria);
    }

    //Settings Props
    compProps = await agent.getSettingsProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //Get user role Props
    compProps = await agent.getSupportedRolesProps({});

    if (compProps) {
      content = { ...content, ...compProps };
    }

    //UserLists Props
    compProps = await agent.getUserListsProps({
      ...args,
      criteria: { ...this.criteria, ...args?.criteria },
    });
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }
  public async getPageContentdelegate(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    if (args?.criteria) {
      this.setCriteriaDelegate(args?.criteria);
    }

    //Settings Props
    compProps = await agent.getSettingsProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //Get user role Props
    compProps = await agent.getSupportedRolesProps({});

    if (compProps) {
      content = { ...content, ...compProps };
    }

    //UserLists Props
    compProps = await agent.getUserListsDelegateProps({
      ...args,
      criteria: { ...this.criteria, ...args?.criteria },
    });
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async inviteUser(args: any) {
    const agent = getAgent();
    return agent.getInviteUser(args);
  }
  public async whiteListUser(args: any) {
    const agent = getAgent();
    return agent.getDelegateWhiteList(args);
  }

  public async blacklistUser(args: any) {
    log.info(`blacklist  user service`, args);
    const agent = getAgent();
    return agent.getBlacklistUser(args);
  }
}
